<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_10"> <CustomDatePicker v-model="fromDate"/> ~ <CustomDatePicker v-model="toDate"/></span>
				<sales-group v-model="salesGroupCode" ref="salesGroup" :allSelect="false" />

				<span class="mgr_10">
					<CountrySelect v-model="country" :bool="true" @us_code="code => (us_code = code)" />
					<label><input type="checkbox" v-model="nonUSYn" @change="changeNonUSYn" true-value="Y" false-value="N" /> Non-US</label>
				</span>

				<StateSelect v-model="state" :country="country" class="mgr_15" />

				<a href="javascript:void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript:void(0);" class="gray_bt" @click="reset()">Reset</a>

				<Select-partners v-model="partner_string" ref="selectPartners" :name="'Ship to'" class="mgb_5" />
				<p class="mgb_5">
					<em class="lt_text">Item {{ headers.class }} Group</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :descWidth="100" :codes="classGroups" v-model="classGroup" /> </span>

					<em class="lt_text">Dept A</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :width="50" :descWidth="70" :codes="deptAs" v-model="deptA" /> </span>

					<em class="lt_text">Dept B</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :width="50" :descWidth="70" :codes="deptBs" v-model="deptB" /> </span>

					<em class="lt_text">Category</em>
					<span class="int_type_no_border mgr_5"> <CodeSelect :width="100" :codeWidth="110" :nameWidth="500" :codes="categories" :showDesc="false" v-model="category" /> </span>
				</p>
				<item-class-select-multi-s v-model="itemClasses" ref="itemClass" />
				<SelectItemClassesByUDG @change="setItemClassesByUDG" ref="itemClassByUDG" />
			</div>
		</div>

		<table class="list_tbl">
			<tbody>
				<template v-for="(sales, idx) in root">
					<tr :key="idx + '_header'">
						<td colspan="1000" class="bold_t">{{ sales.sales_group_code }} / {{ sales.sales_group_name }} {{ sales.from_date }} ~ {{ sales.to_date }}</td>
					</tr>
					<tr :key="idx">
						<td>{{ headers.class }} Name</td>
						<template v-for="(partner, jIdx) in sales.partners">
							<td class="al_center bold_t" :key="idx + '/' + jIdx">{{ partner.partner_code }}</td>
						</template>
						<td class="al_center bold_t">GRAND TOTAL</td>
					</tr>
					<tr v-for="(cls, kIdx) in sales.classes" :key="idx + '/' + kIdx">
						<td>{{ cls.class_name }}</td>
						<template v-for="(partner, lIdx) in sales.partners">
							<td class="al_right" :key="idx + '/' + kIdx + '/' + lIdx">{{ sales[partner.partner_code][cls.class_code] | toCurrency }}</td>
						</template>
						<td class="al_right">{{ cls.totalAmt | toCurrency }}</td>
					</tr>
					<tr :key="idx + '_bottom'">
						<td>GRAND TOTAL</td>
						<td class="al_right" v-for="(partner, jIdx) in sales.partners" :key="'bottom/' + idx + '/' + jIdx">
							{{ partner.totalAmt | toCurrency }}
						</td>
						<td class="al_right">{{ sales.sumTotalAmt | toCurrency }}</td>
					</tr>
				</template>
			</tbody>
		</table>
		<div v-if="root && root.length > 0" class="bottom_bt_box">
			<ul>
				<li>
					<a href="javascript:void(0);" v-on:click="excel()">Excel</a>
				</li>
				<li>
					<a href="javascript:void(0);" v-on:click="print()">Print</a>
				</li>
				<li>
					<label>
						<input type="checkbox" v-model="div_by_state" />
						<em class="lt_text">Print Divided by State</em>
					</label>
				</li>
			</ul>
		</div>
		<!-- excel 출력용 -->
		<table style="display: none;" id="excelTable">
			<tbody>
				<template v-for="(sales, idx) in root">
					<tr :key="idx + '_header'">
						<td colspan="1000" class="bold_t">{{ sales.sales_group_code }} / {{ sales.sales_group_name }} {{ sales.from_date }} ~ {{ sales.to_date }}</td>
					</tr>
					<tr :key="idx">
						<td>{{ headers.class }} Name</td>
						<template v-for="(partner, jIdx) in sales.partners">
							<td class="al_center bold_t" :key="idx + '/' + jIdx">{{ partner.partner_code }}</td>
						</template>
						<td class="al_center bold_t">GRAND TOTAL</td>
					</tr>
					<tr v-for="(cls, kIdx) in sales.classes" :key="idx + '/' + kIdx">
						<td>{{ cls.class_name }}</td>
						<template v-for="(partner, lIdx) in sales.partners">
							<td class="al_right" :key="idx + '/' + kIdx + '/' + lIdx">
								<span v-if="sales[partner.partner_code][cls.class_code]">
									{{ sales[partner.partner_code][cls.class_code] | toCurrency }}
								</span>
							</td>
						</template>
						<td class="al_right">
							<span v-if="cls.totalAmt">{{ cls.totalAmt | toCurrency }}</span>
						</td>
					</tr>
					<tr :key="idx + '_bottom'">
						<td>GRAND TOTAL</td>
						<td class="al_right" v-for="(partner, jIdx) in sales.partners" :key="'bottom/' + idx + '/' + jIdx">
							<span v-if="partner.totalAmt">
								{{ partner.totalAmt | toCurrency }}
							</span>
						</td>
						<td class="al_right">
							<span v-if="sales.sumTotalAmt">{{ sales.sumTotalAmt | toCurrency }}</span>
						</td>
					</tr>
				</template>
			</tbody>
		</table>
	</div>
</template>

<script>
import ItemClassSelectMultiS from '@/components/common/ItemClassSelectMultiS';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import SalesGroup from '@/components/common/SalesGroup';
import StateSelect from '@/components/common/StateSelect';
import CountrySelect from '@/components/common/CountrySelect';
import SelectItemClassesByUDG from '@/components/common/SelectItemClassesByUDG';
import CodeSelect from '@/components/common/CodeSelect';
import SelectPartners from '@/components/common/SelectPartners';
import { exportExcel, objectToFormData, reportMrtUrl, reportRenderHorizontally, excelComplicated } from '@/api/util';
import { apiLandingRegion } from '@/api/report/report';
import { apiIndex } from '@/api/item/class.js';
import { today } from '@/utils/date';

import XLSX from 'xlsx-js-style';

export default {
	props: ['headers'],
	name: 'LandingRegion',
	data: function() {
		return {
			classGroups: [],
			deptAs: [],
			deptBs: [],
			categories: [],

			classGroup: '',
			deptA: '',
			deptB: '',
			category: '',

			salesGroupCode: '',
			itemClasses: [],
			itemClassesByUserDefinedGroup: [],
			fromDate: today(),
			toDate: today(),
			country: '',
			state: '',
			nonUSYn: 'N',
			us_code: '',
			ship_to_code: [],

			root: [],
			itemClassesAsRes: [],
			partner_string: '',

			div_by_state: false,
		};
	},
	components: {
		CountrySelect,
		StateSelect,
		ItemClassSelectMultiS,
		CustomDatePicker,
		SalesGroup,
		SelectItemClassesByUDG,
		SelectPartners,
		CodeSelect,
	},
	computed: {
		isCountryOrStateSelected: {
			get() {
				return !!this.country || !!this.state;
			},
		},
	},
	watch: {
		isCountryOrStateSelected: {
			handler() {
				if (this.nonUSYn === 'Y' && this.isCountryOrStateSelected) this.nonUSYn = 'N';
			},
		},
	},
	methods: {
		async search() {
			// if (this.partner_string) this.ship_to_code = this.partner_string.split(',');
			// else this.ship_to_code = [];

			this.ship_to_code = this.partner_string ? this.partner_string.split(/ |,/) : [];

			if (!this.classGroup && !this.deptA && !this.deptB && !this.category && this.itemClasses.length < 1 && this.itemClassesByUserDefinedGroup.length < 1 && this.ship_to_code.length < 1) {
				this.$toast.error(`Item ${this.headers.class} OR ship to code is empty.`);
				return false;
			}

			const param = {
				item_classes: [...this.itemClasses, ...this.itemClassesByUserDefinedGroup],
				ship_to_code: this.ship_to_code,
				from_date: this.fromDate || '',
				to_date: this.toDate || '',
				sales_group_code: this.salesGroupCode || '',
				country: (this.nonUSYn === 'Y' ? this.us_code : this.country) || '',
				state: this.state || '',
				non_us_yn: this.nonUSYn === 'Y' ? 'Y' : 'N',
				class_group: this.classGroup || '',
				dept_a: this.deptA || '',
				dept_b: this.deptB || '',
				category: this.category || '',
			};

			const { data } = await apiLandingRegion(objectToFormData(param));
			this.itemClassesAsRes = data.classList.map(ic => ({ class_code: ic.code, class_name: ic.name }));
			this.root = this.reorganizeData(data.landingRegion);
		},
		reorganizeData(data) {
			data.forEach(el => {
				const print_item_list = [];
				let sumTotalAmt = 0;

				if (this.state) el.state = this.state;
				el.from_date = this.fromDate;
				el.to_date = this.toDate;
				el.classes = this.itemClassesAsRes.map(ic => ({ class_code: ic.class_code, class_name: ic.class_name, totalAmt: 0 }));
				el.partner_cnt = el.partners.length;
				el.class_cnt = el.classes.length;

				el.partners.forEach(p => {
					p.totalAmt = 0;
					el.classes.forEach(ic => {
						if (!el[p.partner_code]) el[p.partner_code] = {};

						const idx = el.itemList.findIndex(it => it.partner_code === p.partner_code && it.class_code === ic.class_code);
						const amount = idx > -1 ? el.itemList[idx].amount : 0;
						el[p.partner_code][ic.class_code] = amount;
						print_item_list.push({ class_code: ic.class_code, partner_code: p.partner_code, amount: amount });

						p.totalAmt += el[p.partner_code][ic.class_code];
						ic.totalAmt += el[p.partner_code][ic.class_code];
					});
					sumTotalAmt += p.totalAmt;
				});

				el.sumTotalAmt = sumTotalAmt;
				el.itemList = print_item_list;
			});

			return data;
		},
		changeNonUSYn() {
			if (this.nonUSYn === 'Y') {
				this.country = '';
				this.state = '';
			} else {
				this.country = this.us_code;
				this.state = '';
			}
		},
		setShip(partner) {
			this.ship_to_code = partner.code;
		},
		reset() {
			this.fromDate = today();
			this.toDate = today();
			this.$refs.salesGroup.reset();
			this.$refs.selectPartners.reset();
			this.$refs.itemClass.reset();
			this.$refs.itemClassByUDG.reset();

			this.classGroup = '';
			this.deptA = '';
			this.deptB = '';
			this.category = '';
		},
		setItemClassesByUDG(itemClasses) {
			this.itemClassesByUserDefinedGroup = itemClasses;
		},
		divideByState() {
			const print_list = [];
			this.root.forEach(el => {
				const state_list = [];
				el.partners.forEach(p => {
					const idx = state_list.findIndex(st => st.state === p.address_state);
					if (idx < 0) state_list.push({ state: p.address_state, partners: [p] });
					else state_list[idx].partners.push(p);
				});

				state_list.forEach(st => {
					const new_el = {
						sales_group_code: el.sales_group_code,
						sales_group_name: el.sales_group_name,

						from_date: el.from_date,
						to_date: el.to_date,
						state: st.state,
						partner_cnt: st.partners.length,
						class_cnt: el.class_cnt,

						partners: st.partners,
						classes: this.itemClassesAsRes.map(ic => ({ class_code: ic.class_code, class_name: ic.class_name, totalAmt: 0 })),
						itemList: el.itemList.filter(it => st.partners.some(p => p.partner_code === it.partner_code)),
					};
					print_list.push(new_el);
				});
			});

			return print_list;
		},
		getPrintData(root) {
			const print_data = [];
			const partner_cnt_per_page = 10;
			root.forEach(el => {
				const roof_cnt = Math.ceil(el.partner_cnt + 1 / partner_cnt_per_page); // + 1: Total 열 추가
				const partners_copy = [...el.partners];
				const total_obj = { partner_code: '<<TOTAL>>', partner_name: '<<TOTAL>>' };
				partners_copy.push(total_obj);

				const itemList_copy = [...el.itemList];
				// const classes_copy = this.itemClassesAsRes.map(ic => ({ class_code: ic.class_code, class_name: ic.class_name, totalAmt: 0 }));
				// classes_copy.forEach(cls => {
				el.classes.forEach(cls => {
					const total_amt = el.itemList.filter(it => it.class_code === cls.class_code).reduce((acc, curr) => acc + curr.amount, 0);
					itemList_copy.push({ class_code: cls.class_code, partner_code: total_obj.partner_code, amount: total_amt });

					// if (total_amt === 0) cls.class_name = '(*) ' + cls.class_name;
				});

				for (let i = 0; i < roof_cnt; i++) {
					const start_idx = partner_cnt_per_page * i;
					const end_idx = partner_cnt_per_page * (i + 1) < partners_copy.length ? partner_cnt_per_page * (i + 1) : partners_copy.length;
					const partners = partners_copy.slice(start_idx, end_idx);
					const itemList = itemList_copy.filter(it => partners.some(p => p.partner_code === it.partner_code));
					const obj = {
						sales_group_code: el.sales_group_code,
						sales_group_name: el.sales_group_name,

						from_date: el.from_date,
						to_date: el.to_date,
						state: el.state,
						partner_cnt: el.partner_cnt,
						class_cnt: el.class_cnt,

						partners: partners,
						// classes: classes_copy,
						classes: this.itemClassesAsRes.map(ic => ({ class_code: ic.class_code, class_name: ic.class_name, totalAmt: 0 })),
						itemList: itemList,
					};

					print_data.push(obj);
				}
			});

			return print_data;
		},
		async print() {
			const print_data = this.getPrintData(this.div_by_state ? this.divideByState() : this.root);
			// console.log(JSON.stringify(print_data, null, 4));
			await reportRenderHorizontally(print_data, 'LandingRegion', reportMrtUrl('LandingRegion'));
		},
		excelBackUp() {
			const eid = 'excelTable';
			const fileName = 'Landing Region Report';
			exportExcel(eid, fileName);
		},
		excel() {
			const data = [[{ t: 's', v: 'Landing Region', cs: 10 }]];
			const root = this.div_by_state ? this.divideByState() : this.root;
			root.forEach(el => {
				// header
				data.push([{ t: 's', v: `${el.sales_group_code} / ${el.sales_group_name}  ${el.from_date} ~ ${el.to_date}   ${el.state ? 'STATE: ' + el.state : ''} / Partner: ${el.partner_cnt} / Item Class: ${el.class_cnt}`, cs: 10 }]);
				const header = [{ t: 's', v: 'Item Class' }];
				el.partners.forEach(p => header.push({ t: 's', v: p.partner_code }));
				header.push({ t: 's', v: 'TOTAL' });
				data.push(header);

				const p_total_arr = [];
				el.classes.forEach(c => {
					const row = [{ t: 's', v: c.class_name }];
					let c_total = 0;
					el.partners.forEach((p, index) => {
						let amount = 0;
						let idx = el.itemList.findIndex(it => it.partner_code === p.partner_code && it.class_code === c.class_code);
						if (idx > -1) {
							amount = el.itemList[idx].amount;
							c_total += amount;
							row.push({ t: 'n', v: amount });
						} else {
							row.push({ t: 's', v: '' }); // { t: 'n', v: null } ??
						}

						if (p_total_arr.length - 1 < index) p_total_arr.push(amount);
						else p_total_arr[index] += amount;
					});
					row.push({ t: 'n', v: c_total });
					data.push(row);
				});

				const p_total_row = p_total_arr.map(pt => ({ t: 'n', v: pt }));
				p_total_row.unshift({ t: 's', v: 'TOTAL' });
				p_total_row.push({ t: 'n', v: p_total_arr.reduce((prev, curr) => prev + curr, 0) });

				data.push(p_total_row);
				data.push([]);
			});

			XLSX.writeFile(
				{
					SheetNames: ['Sheet1'],
					Sheets: {
						Sheet1: excelComplicated(data),
					},
				},
				'LandingRegion.xlsx',
			);

			// XLSX.writeFile(
			// 	{
			// 		SheetNames: ['Sheet1'],
			// 		Sheets: {
			// 			Sheet1: {
			// 				'!ref': 'A1:B2',
			// 				A1: { t: 's', v: 'A1:A2' },
			// 				B1: { t: 'n', v: 1, s: { numFmt: '#,###.00' } }, // number format 안 됨.
			// 				B2: { t: 'b', v: true },
			// 				'!merges': [{ s: { r: 0, c: 0 }, e: { r: 1, c: 0 } } /* A1:A2 */],
			// 			},
			// 		},
			// 	},
			// 	'test.xlsx',
			// );
		},
		async init() {
			const { data } = await apiIndex();

			this.classGroups = data.classGroupList;
			this.deptAs = data.deptAList;
			this.deptBs = data.deptBList;
			this.categories = data.categoryList;
		},
	},
	created() {
		this.init();

		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_landingRegion');
		this.$store.commit('setSubTitle', 'Report -> Landing Region');
	},
};
</script>

<style scoped></style>
